import React, { useEffect, useState } from 'react'
import { FaSearch, FaBell, FaPlus, FaInbox, FaCodeBranch,FaList } from "react-icons/fa";
import OrgAdminCreate from './OrgAdminCreate';
import OrgAdminEdit from './OrgAdminEdit';
import OrgAdminRead from './OrgAdminRead';
import OrgAdminList from './OrgAdminList';
import { useLocation } from 'react-router';
import CategoryAdmin from './CategoryAdmin';
import SubCategoryAdmin from './SubCategoryAdmin';
import { CategoryPut, OrgMetaUpdate, SubCategoryPut } from '../../../api/orgService';
import MetadataAdmin from './MetadataAdmin';

function OrgAdmin() {

  const location = useLocation()
  const [activeAction,setActiveAction] = useState("org-list-view")

  const navItems = [
    { label: 'Create Organisation',  path: '/staff/organisation/create',tab:'create-org' },
    { label: 'Organisation',  path: '/staff/organisation/detail',tab:'org-detail-view'  },
    { label: 'Edit Organisation',  path: '/staff/organisation/edit',tab:'edit-org' },
    { label: 'List Organisations',  path: '/staff/organisation',tab:'list-org' },
    { label: 'View Category',  path: '/staff/organisation/category/veiw',tab:'view-category' },
    { label: 'View SubCategory',  path: '/staff/organisation/subcategory',tab:'view-subcategory' },
  ];

  
   useEffect(()=>{
      console.log(location)
      if(location?.pathname==="/staff/organisation/create/" && activeAction !== "create-org"){
        setActiveAction("create-org")
      }else if(location?.pathname==="/staff/organisation/detail/"  && activeAction !== "org-detail-view"){
        setActiveAction("org-detail-view")
      }else if(location?.pathname.includes("/staff/organisation/detail/") && activeAction !== "org-detail-view"){
        setActiveAction("org-detail-view")
      }else if(location?.pathname==="/staff/organisation/edit/" && activeAction !== "edit-org"){
        setActiveAction("org-view")
      }else if(location?.pathname==="/staff/organisation/" && activeAction !== "list-org"){
        setActiveAction("list-org")
      }else if(location?.pathname==="/staff/organisation/category/view/" && activeAction !== "view-category"){
        setActiveAction("view-category")
      }else if(location?.pathname==="/staff/organisation/subcategory/view/" && activeAction !== "view-subcategory"){
        setActiveAction("view-subcategory")
      }else if(location?.pathname==="/staff/organisation/metadata/view/" && activeAction !== "view-metadata"){
        setActiveAction("view-metadata")
      }
    },[location?.pathname])

     useEffect(()=>{
      if(location?.state?.redirect){
        setActiveAction(location?.state?.redirect)
      }
    },[location])
    const CreateOrg = (e)=>{
      e.preventDefault()
      setActiveAction("create-org")
    }

    const EditOrg = (e)=>{
      e.preventDefault()
      setActiveAction("edit-org")
    }

    const ListOrgs = (e)=>{
      e.preventDefault()
      setActiveAction("list-org")
    }


    const views = {
      "create-org":<OrgAdminCreate/>,
      "create-edit":<OrgAdminEdit/>,
      "org-detail-view":<OrgAdminRead/>,
      "list-org": <OrgAdminList/>,
      "view-category": <CategoryAdmin onAddcategory={CategoryPut}/>,
      "view-subcategory": <SubCategoryAdmin onAddSubcategory={SubCategoryPut}/>,
      "view-metadata": <MetadataAdmin onAddcategory={OrgMetaUpdate}/>
    }

  return (
    <div>
            {/* <h3>ProjectAdmin</h3> */}
        <header className="projects-header-admin">
          <h1 className="header-title-admin">My Organisation Admin</h1>
    
          <div className="header-controls-admin">
            <div className="search-container">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Type / to search"
                className="search-input"
              />
            </div>
    
            <div className="icon-group">
              <button className="icon-button tooltip-container" onClick={CreateOrg}>
                <FaPlus /> <span>New Organisation</span> <span class="tooltip-content">Add New Organisation</span>
              </button>
              <button className="icon-button tooltip-container" onClick={ListOrgs}>
                <FaList /> <span>View Organisations</span> <span class="tooltip-content">List All Organisations</span>
              </button>
              <button className="icon-button">
                <FaCodeBranch />
              </button>
              <button className="icon-button">
                <FaInbox />
              </button>
            </div>
          </div>
        </header>
        <div className="admin-org-home">
          {
            views[activeAction] || views['list-org']
          }
        </div>
        </div>
  )
}

export default OrgAdmin

// New Organisation
// New Partner
// New Categories
// 